import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getPharmacyPatients({ pharmacyId, page, limit, order, orderBy }) {
    const queryParams = new URLSearchParams();
    if (typeof page === 'number') queryParams.set('page', page);
    if (typeof limit === 'number') queryParams.set('limit', limit);
    if (typeof order === 'string') queryParams.set('order', order);
    if (typeof orderBy === 'string') queryParams.set('order_by', orderBy);

    const resourcePath = `/pharmacies/${pharmacyId}/patients`;
    const queryString = queryParams.toString();
    const resourceFullUrl = [resourcePath, queryString].filter(Boolean).join('?');
    const response = await axiosPrivate.get(resourceFullUrl, {
      headers: { 'accept-version': '2.0.0' },
    });
    if (response.data.error) helpers.throwError(response.data.error);

    return {
      patients: response.data.data,
      pagination: response.data.pagination,
    };
  },

  async getPharmacyPatientsV3({ pharmacyId, page, limit, order, filter, searchQuery, sortBy }) {
    const queryParams = new URLSearchParams();
    if (typeof page === 'number') queryParams.set('page', page);
    if (typeof limit === 'number') queryParams.set('limit', limit);
    if (typeof order === 'string') queryParams.set('order', order);
    if (typeof filter === 'string') queryParams.set('filter', filter);
    if (typeof sortBy === 'string') queryParams.set('sortBy', sortBy);
    if (typeof searchQuery === 'string' && searchQuery.trim()) {
      queryParams.set('query', searchQuery);
    }

    const resourcePath = `/v3/pharmacies/${pharmacyId}/patients`;
    const queryString = queryParams.toString();

    const response = await axiosPrivate.get([resourcePath, queryString].filter(Boolean).join('?'));
    if (response.data.error) helpers.throwError(response.data.error);

    return {
      patients: response.data.patients,
      pagination: response.data.pagination,
    };
  },

  async searchPharmacyPatient({ pharmacyId, patientName }) {
    const queryParams = new URLSearchParams({ patient_name: patientName });
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/patients/search?${queryParams.toString()}`,
      { headers: { 'accept-version': '2.0.0' } }
    );
    if (response.data.error) helpers.throwError(response.data.error);

    return {
      patients: response.data.data,
    };
  },

  async getPatientMedicines({ patientId, options = {} }) {
    const queryParams = new URLSearchParams(options);

    const resourcePath = `/patients/${patientId}/remedies`;
    const queryString = queryParams.toString();
    const resourceFullUrl = [resourcePath, queryString].filter(Boolean).join('?');

    const response = await axiosPrivate.get(resourceFullUrl, {
      headers: { 'accept-version': '2.0.0' },
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getPatientInfo({ patientId }) {
    const response = await axiosPrivate.get(`/patients/${patientId}`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getPatientOrders({ patientId, page, limit }) {
    const queryParams = new URLSearchParams();
    if (typeof page === 'number') queryParams.set('page', page);
    if (typeof limit === 'number') queryParams.set('limit', limit);

    const resourcePath = `/patients/${patientId}/orders`;
    const queryString = queryParams.toString();
    const resourceFullUrl = [resourcePath, queryString].filter(Boolean).join('?');

    const response = await axiosPrivate.get(resourceFullUrl);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
